export const shortcuts = (index) => {
  const time = new Date()
  const end = new Date(`${time.getFullYear()}/${time.getMonth() + 1}/${time.getDate()} 00:00:00`)
  const start = new Date(`${time.getFullYear()}/${time.getMonth() + 1}/${time.getDate()} 00:00:00`)
  if (index === 0) {
    return [start, end]
  }else if (index === 1) {
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    return [start, end]
  } else if (index === 2) {
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 60)
    return [start, end]
  } else if (index === 3) {
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
    return [start, end]
  }
}